import { useEffect, useRef } from 'react';
// usePrevious is used for getting the previous value of props or states
export function usePrevious(value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    }, [value]);
    return ref.current;
}
//# sourceMappingURL=usePrevious.js.map